import { learnerPaths } from '@app/routes/route-paths'
import type { LearnerRouteDefinition } from '@app/routes/learner-route-types'

export const premiumRouteDefinitions = [
  {
    id: 'premium',
    legacyScreen: 6,
    path: learnerPaths.premium,
    title: 'Premium',
  },
  {
    id: 'activation-key',
    legacyScreen: 6,
    navLabel: 'Activation key',
    opensActivationKey: true,
    path: learnerPaths.activationKey,
    showInMainMenu: true,
    title: 'Activation key',
  },
  {
    id: 'teachers',
    legacyScreen: 5,
    path: learnerPaths.teachers,
    title: 'Find teachers',
  },
] satisfies readonly LearnerRouteDefinition[]
